import styled from '@emotion/styled';
import InfiniteScroll from 'aquilla/core/organisms/InfiniteScroll';
import { mediaQuery, Spacings } from '@styles/index';

// eslint-disable-next-line import/prefer-default-export
export const StyledInfiniteScroll = styled(InfiniteScroll)`
  grid-column: span 18;
  margin-top: ${Spacings.SPACING_6B};
  display: grid;
  justify-items: center;
  grid-template-columns: repeat(3, 1fr);
  gap: ${Spacings.SPACING_4B};

  ${mediaQuery.uptoTablet} {
    grid-template-columns: repeat(2, 1fr);
    margin: auto;
  }

  ${mediaQuery.uptoMobile} {
    grid-template-columns: repeat(1, 1fr);
    margin: auto;
  }
`;
